import React from 'react'
import { Card, CardContent } from '@material-ui/core'
import { SalesLeadTimeDataset } from 'controllers/Analytics/SalesLeadTimeController'
import moment from 'moment'
import {
  CartesianGrid,
  XAxis,
  YAxis,
  ZAxis,
  Scatter,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  Line,
  Legend,
  TooltipProps,
  Text,
} from 'recharts'

const XAxisTransformUnixTime = (props: {
  x: number
  y: number
  stroke: string
  payload: { value: number }
  fill: string
}) => {
  const { x, y, stroke, payload, fill } = props

  return (
    <g transform={`translate(${x},${y})`}>
      <text stroke={stroke} x={0} y={0} dy={16} textAnchor="middle" fill={fill}>
        {moment(new Date(0).setUTCSeconds(payload.value)).format('DD-MM')}
      </text>
    </g>
  )
}

const YAxisTransformSeconds = (props: {
  x: number
  y: number
  stroke: string
  payload: { value: number }
  fill: string
}) => {
  const { x, y, stroke, payload, fill } = props

  const duration = moment.duration(payload.value, 'seconds')

  return (
    <g transform={`translate(${x},${y})`}>
      <Text
        width={90}
        stroke={stroke}
        x={0}
        y={0}
        dy={0}
        textAnchor="end"
        fill={fill}
      >
        {duration.humanize()}
      </Text>
    </g>
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomTooltip = (props: TooltipProps<any, any>) => {
  if (!props.active || props.payload[0]?.dataKey !== 'leadtime') return null

  return (
    <Card component="ul" className="graph-tooltip">
      <CardContent>
        {props.payload.map((x) => {
          return Object.keys(x.payload).map((key) => {
            if (key === 'unixtimeinseconds') {
              return null
            }

            return (
              <li key={key}>
                <strong>{key}</strong>
                <p>
                  {key === 'leadtime'
                    ? moment.duration(x.payload[key], 'seconds').humanize({
                        M: 12,
                        d: 30,
                        h: 24,
                        m: 60,
                        s: 60,
                        ss: 0,
                      })
                    : x.payload[key]}
                </p>
              </li>
            )
          })
        })}
      </CardContent>
    </Card>
  )

  // <pre style={{ overflow: 'auto', height: '100px' }}>
  //   {JSON.stringify(props, null, 2)}
  // </pre>
}

export const SalesLeadTimeGraph = (props: { data: SalesLeadTimeDataset[] }) => {
  return (
    <ResponsiveContainer>
      <ComposedChart data={props.data}>
        <CartesianGrid stroke="#D0D1CD" />
        <XAxis
          type="number"
          dataKey="unixtimeinseconds"
          name="date"
          domain={['dataMin', 'dataMax']}
          tick={(props) => <XAxisTransformUnixTime {...props} />}
        />
        <YAxis
          type="number"
          name="lead time"
          interval={'preserveStartEnd'}
          domain={['dataMin', 'dataMax']}
          tick={(props) => <YAxisTransformSeconds {...props} />}
          width={90}
        />
        <ZAxis
          type="number"
          dataKey="projectcount"
          range={[0, 200]}
          name="projects"
          unit=" ordered"
        />
        <Tooltip
          cursor={{ strokeDasharray: '3 3' }}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          content={(props: TooltipProps<any, any>) => (
            <CustomTooltip {...props} />
          )}
          allowEscapeViewBox={{ x: false, y: true }}
        />
        <Scatter
          dataKey="leadtime"
          name="Sales lead time"
          fill="#8884d8"
          legendType="none"
          lineType="fitting"
        ></Scatter>
        <Line
          name="target"
          dataKey="targetLeadTime"
          stroke="hsl(141, 53%, 53%)"
          strokeWidth={4}
          dot={false}
          activeDot={false}
        />
        <Legend />
      </ComposedChart>
    </ResponsiveContainer>
  )
}
